import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  instanceId: number | null;
  isAuthenticated: boolean;
}

interface AuthActions {
  setTokens: (
    accessToken: string,
    refreshToken: string,
    instanceId: number,
  ) => void;
  setAuthenticated: (isAuthenticated: boolean) => void;
  logout: () => void;
  getAccessToken: () => string | null;
  getRefreshToken: () => string | null;
}

const initialState: AuthState = {
  accessToken: null,
  refreshToken: null,
  instanceId: null,
  isAuthenticated: false,
};

export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set, get) => ({
      ...initialState,

      setTokens: (
        accessToken: string,
        refreshToken: string,
        instanceId: number,
      ) => {
        set({ accessToken, refreshToken, instanceId, isAuthenticated: true });
      },

      setAuthenticated: (isAuthenticated: boolean) => {
        set({ isAuthenticated });
      },

      logout: () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("instance_id");
        set({ ...initialState });
      },

      getAccessToken: () => {
        return get().accessToken || localStorage.getItem("access_token");
      },

      getRefreshToken: () => {
        return get().refreshToken || localStorage.getItem("refresh_token");
      },
    }),
    {
      name: "cryptcloud-auth-storage",
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        instanceId: state.instanceId,
        isAuthenticated: state.isAuthenticated,
      }),
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
